import { PlainButton } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { useEditorToolbar } from "@jugl-web/domain-resources/common/components/RichTextarea";
import { useMemo } from "react";
import { useDeepCompareEffect } from "react-use";
import { ReactComponent as BoldIcon } from "./assets/bold.svg";
import { ReactComponent as ItalicIcon } from "./assets/italics.svg";
import { ReactComponent as UnderlineIcon } from "./assets/underline.svg";
import { ReactComponent as StrikethroughIcon } from "./assets/strikethrough.svg";
import { ReactComponent as ListIcon } from "./assets/list.svg";
// import { ReactComponent as OrderedListIcon } from "./assets/ordered-list.svg";

const IconBtn = ({
  isActive,
  icon,
  onClick,
}: {
  isActive: boolean;
  icon: React.ReactNode;
  onClick: () => void;
}) => (
  <PlainButton
    className={cx(
      "flex h-8 w-8 cursor-pointer items-center justify-center rounded hover:bg-dark-100",
      {
        "bg-primary-50": isActive,
      }
    )}
    onClick={onClick}
  >
    {icon}
  </PlainButton>
);

export const ChatInputTextFormattingBar: React.FC<{
  isOpen: boolean;
  onUpdate: () => void;
}> = ({ isOpen, onUpdate }) => {
  const { toolbarState, formatSelection, insertList } = useEditorToolbar();

  useDeepCompareEffect(() => {
    onUpdate();
  }, [toolbarState, onUpdate]);

  const buttons = useMemo(
    () => ({
      bold: {
        icon: <BoldIcon />,
        onClick: () => {
          formatSelection("bold");
        },
        isActive: toolbarState.isBold,
      },
      italic: {
        icon: <ItalicIcon />,
        onClick: () => {
          formatSelection("italic");
        },
        isActive: toolbarState.isItalic,
      },
      underline: {
        icon: <UnderlineIcon />,
        onClick: () => {
          formatSelection("underline");
        },
        isActive: toolbarState.isUnderline,
      },
      strikethrough: {
        icon: <StrikethroughIcon />,
        onClick: () => {
          formatSelection("strikethrough");
        },
        isActive: toolbarState.isStrikethrough,
      },
      list: {
        icon: <ListIcon />,
        onClick: () => {
          insertList(toolbarState.listType === "bullet" ? null : "bullet");
        },
        isActive: toolbarState.listType === "bullet",
      },
      // orderedList: {
      //   icon: <OrderedListIcon />,
      //   onClick: () => {
      //     insertList(toolbarState.listType === "number" ? null : "number");
      //   },
      //   isActive: toolbarState.listType === "number",
      // },
    }),
    [
      formatSelection,
      insertList,
      toolbarState.isBold,
      toolbarState.isItalic,
      toolbarState.isStrikethrough,
      toolbarState.isUnderline,
      toolbarState.listType,
    ]
  );

  if (!isOpen) return null;
  return (
    <div className="-mx-4 -mt-1 mb-[18px] flex h-10 gap-4 border-0 border-b border-solid border-dark-100 px-4">
      {Object.entries(buttons).map(([key, { isActive, icon, onClick }]) => (
        <IconBtn key={key} isActive={isActive} icon={icon} onClick={onClick} />
      ))}
    </div>
  );
};
